import { Component, OnInit } from '@angular/core';

import { AboutService } from './../../services/about.service';
import { SocialRedesService } from './../../services/social-redes.service';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.css']
})
export class HeroComponent implements OnInit {

  socialreds: any[];
  titular: any;

  constructor(private socialService: SocialRedesService,
              private aboutService: AboutService) {

    this.socialreds = socialService.socialred;
    // console.log(this.socialreds);

    this.titular = aboutService.titular;
    // console.log(this.titular);

  }

  ngOnInit(): void {
  }

}
